import axios from 'axios';

export type APIResult = {
    status: number,
    data?: any
    error?: APIError
}

export type APIError = {
    code: number,
    msg: string
}

export type GetPublicMintRes = {
    status: number,
    countdown_timer?: number,
    curBatchInfo?:GetCurrentBatchInfoRes,
    error?: APIError,
     //FIX ME: futur counter is not part of GetPublicMintRes
    future_countdownTimer?:Date
}

export type GetCurrentBatchInfoRes = {
    type: string,
    batch: number,
    mintStartInMs?: number,
    mintEndInMs?: number,
    wlDecisionIn?: number,
    candyMachine?: string,
    wlToken?:string,
  }

//
export async function getPublicMint(address: string): Promise<GetPublicMintRes> {

    try {
        let url = `${process.env.NEXT_PUBLIC_API_URL}/mint/getPublicMint`;

        let reqData = {
            address,
            isTest: true // Used for test mode!
        }

        let res = await axios.post(url, reqData);

        if (res.data.status >= 0) {

            console.log("RES ", res)
            return {
                status: res.data.status,
                countdown_timer: res.data.countdown_timer,
                curBatchInfo: res.data.curPubBatchInfo
            };
        } else {
            return { status: -1, error: { code: -5, msg: "error" } }
        }
    } catch (error: any) {
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.error('Error', error.response.data);
            console.error('Error', error.response.status);
            console.error('Error', error.response.headers);
        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.error('Error', error.message);
        }

        console.error('Error', error.config);

        return { status: -1, error: { code: -5, msg: "error" } }
    };

}
